<template>
    <div style="width: 366px; height: 100%;">
        <iframe ref="iframe" :src="iframeUrl" v-if="iframeUrl"></iframe>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'ScenarioChat',
    props: {
        active: Boolean
    },
    data () {
        return {
            iframeUrl: '',
            shouldOpenUrl: false
        }
    },
    computed: {
        ...mapState({
            bot: state => state.bot
        })
    },
    mounted () {
        this.refresh()
    },
    methods: {
        refresh () {
            if (!this.bot) {
                return
            }
            if (this.shouldOpenUrl) {
                setTimeout(() => {
                    this.iframeUrl = this.$ut.buildUrl({
                        url: process.env.VUE_APP_LIVECHAT_URL,
                        params: {
                            botcode: this.bot.code,
                            botname: this.bot.name,
                            scendpoint: process.env.VUE_APP_LIVECHAT_ENDPOINT
                        }
                    })
                }, 300)
            }
        }
    },
    watch: {
        active () {
            if (this.active) {
                this.shouldOpenUrl = true
                this.refresh()
            }
        }
    }
}
</script>

<style scoped lang="scss">
iframe {
    border: none;
    width: 100%;
    height: 100%;
}
</style>
